export default __webpack_public_path__ + "static/media/TubeRotor.e50fce23.svg";